import { DocumentLists } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function RegulationsAndPricesArchived() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent spacing="l">
        <DocumentLists
          title="archiwalne regulaminy i cenniki"
          validity="EXPIRED"
        />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
